
import HelloWorld from '@/components/HelloWorld.vue'
import { CounterStore } from '@/store/interfaces/CounterStore'
import { RootState } from '@/store/interfaces/RootState' // @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'

@Component({
    components: {
        HelloWorld
    }
})
export default class Home extends Vue {
    private isOnline = false

    public get cnt(): number {
        return this.counterStore.count
    }

    // - Stores --------------------------------------------------------------------------------

    private get counterStore(): CounterStore {
        return (this.$store.state as RootState).counterStore()
    }

    // - LiveCycle-Hooks -----------------------------------------------------------------------

    public created(): void {
        window.addEventListener('online', () => this.isOnline = true);
        window.addEventListener('offline', () => this.isOnline = false);

        this.isOnline = window.navigator.onLine
    }

}
